import CardWithRoles from "components/card/CardWithRoles";
import rateAgreementsImage from "./rate-agreements.svg";

export default function RateAgreementsCard() {
  return (
    <CardWithRoles
      name="Rate Agreements"
      image={rateAgreementsImage}
      description="View carrier rate agreements, including rate tables with validity periods and individual rates for freight pricing."
      targetRoles={["Logistics", "Pricing"]}
      link="/rate-agreements"
      testid="rate-agreements-card"
    />
  );
}
